import moment from 'moment-timezone';
import { ISessionTimelineSummaryData, ISessionTimelineTableDataItem } from '@src/api/appData';
import { SessionTimelineTableItem, SessionTimelineTableHeader } from '@conviva/organism-components';
import { EmptyArray } from '../constants';

export const formatDate = (timestamp: string) => {
  if (moment(timestamp).isValid()) {
    return moment(timestamp).format('MMM DD YYYY');
  }
  return '';
};

export const formatTime = (timestamp: string) => {
  if (moment(timestamp).isValid()) {
    return moment(timestamp).format('HH:mm:ss');
  }
  return '';
};

export const formatTimeDuration = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  let formattedTime = '';

  if (hours > 0) {
    formattedTime += `${hours}h `;
  }
  if (minutes > 0) {
    formattedTime += `${minutes}m `;
  }
  formattedTime += `${remainingSeconds}s`;

  return formattedTime;
};

export const processSummaryData = (summaryData: ISessionTimelineSummaryData) => {
  const { userInfoData, eventSummaryData } = summaryData ?? {};
  const res: any[] = [];
  if (userInfoData && userInfoData.length > 0) {
    res.push({
      label: 'User Info',
      items: userInfoData.map((item) => ({
        value: item.value,
        label: item.name,
      })),
    });
  }
  if (eventSummaryData && eventSummaryData.length > 0) {
    res.push({
      label: 'Event Summary',
      items: eventSummaryData.map((item) => ({
        value: item.value,
        label: item.name,
      })),
    });
  }
  if (res.length === 0) {
    return EmptyArray;
  }
  return res;
};

export const processSessionTableData = (data: ISessionTimelineTableDataItem[]) => {
  const res: (SessionTimelineTableItem | SessionTimelineTableHeader)[] = [];
  let date = '';
  let index = 1;
  data.forEach((item) => {
    const startDate = formatDate(item.eventTimeStampStart);
    if (startDate !== date) {
      date = startDate;
      res.push({
        isHeader: true,
        headerTitle: startDate,
      });
    }
    const isOutOfSession = item.inSession !== 1;
    const eventTimeStamp = `${formatTime(item.eventTimeStampStart)} - ${formatTime(item.eventTimeStampEnd)}`;
    const userActiveTime = isOutOfSession ? 'NA' : formatTimeDuration(item.userActiveTime);
    const sessionIndex = isOutOfSession ? '*' : index++;
    res.push({
      ...item,
      userActiveTime,
      eventTimeStamp,
      index: sessionIndex,
    });
  });
  return res;
};
